<!-- 
PopupContent.vue
功能：彈跳式廣告_廣告內容
作者：i9400538 陳博承
完成：2021-07-21
-->
<template>
  <div class="container" v-show="isEdit">
    <div class="row">
      <div class="col-12">
        <h4 class="text-green m-0">發文注意事項：</h4>
      </div>
      <div class="col-12">
        <p>
          1. 不得發布身分證字號、保單號碼及其他『足資識別該個人之資料』相關資訊。
          <br />2. 上傳之文件或影片等文件不得構成著作財產權之侵害。
          <br />3. 若有發現違法之情事，經查屬實後管理者得將違法者停權並送人資議處。
          <br />
        </p>
      </div>
      <table class="table table-basic mt-4 mb-4" :class="{ 'readonly-table': isReadOnlyMode() }" @input="markAsEdited" @change="markAsEdited">
        <thead>
          <tr>
            <th class="w-220">輸入人員</th>
            <td>{{ getName }}</td>
          </tr>
          <tr>
            <th class="w-220">
              主旨
              <br />
              <small class="span-color-black">最多20個字元(10個中文字)</small>
            </th>
            <td>
              <input
                type="text"
                maxlength="50"
                :id="`popup-title-${colKey}`"
                :data-vv-name="`popup-title-${colKey}`"
                placeholder="請輸入主旨"
                v-validate="'required'"
                data-vv-as="主旨"
                class="form-control w-50"
                v-model="form.photo_desc"
                alt="ch"
                :class="{ 'is-invalid': errors.has(`popup-title-${colKey}`) }"
                @input="checkTitle"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">發佈日期</th>
            <td>
              <div class="col-10">
                <select
                  :id="`start-date-year-${colKey}`"
                  :data-vv-name="`start-date-year-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-year-${colKey}`) }"
                  v-model="form.start_date[0]"
                  @change="updateDate('start')"
                >
                  <option value>年份</option>
                  <option
                    v-for="(opt, y_opt_i) in yearOpt_start"
                    :key="`start-year-${y_opt_i}`"
                    :value="opt"
                  >{{opt - 1911}}年</option>
                </select>

                <span class="text">/</span>

                <select
                  :id="`start-date-month-${colKey}`"
                  :data-vv-name="`start-date-month-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-month-${colKey}`) }"
                  v-model="form.start_date[1]"
                  @change="updateDate('start')"
                >
                  <option value>月份</option>
                  <option
                    v-for="(opt, m_opt_i) in monthOpt"
                    :key="`start-month-${m_opt_i}`"
                    :value="opt"
                  >{{opt}}月</option>
                </select>

                <span class="text">/</span>

                <select
                  :id="`start-date-day-${colKey}`"
                  :data-vv-name="`start-date-day-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-day-${colKey}`) }"
                  v-model="form.start_date[2]"
                  @change="updateDate('start')"
                >
                  <option value>日期</option>
                  <option
                    v-for="(opt, d_opt_i) in dateOpt_start"
                    :key="`start-date-${d_opt_i}`"
                    :value="opt"
                  >{{opt}}日</option>
                </select>
                &nbsp;
                <select
                  :id="`start-date-time-${colKey}`"
                  :data-vv-name="`start-date-time-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-time-${colKey}`) }"
                  v-model="form.start_date[3]"
                >
                  <option value>時間</option>
                  <option
                    v-for="(opt, t_opt_i) in timeOpt"
                    :key="`start-time-${t_opt_i}`"
                    :value="opt"
                  >{{opt}}</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">下架日期</th>
            <td>
              <div class="col-10">
                <select
                  :id="`end-date-year-${colKey}`"
                  :data-vv-name="`end-date-year-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="下架日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-year-${colKey}`) }"
                  v-model="form.end_date[0]"
                  @change="updateDate('end')"
                >
                  <option value>年份</option>
                  <option
                    v-for="(opt, y_opt_i) in yearOpt_end"
                    :key="`end-year-${y_opt_i}`"
                    :value="opt"
                  >{{opt - 1911}}年</option>
                </select>

                <span class="text">/</span>

                <select
                  :id="`end-date-month-${colKey}`"
                  :data-vv-name="`end-date-month-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="下架日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-month-${colKey}`) }"
                  v-model="form.end_date[1]"
                  @change="updateDate('end')"
                >
                  <option value>月份</option>
                  <option
                    v-for="(opt, m_opt_i) in monthOpt"
                    :key="`end-month-${m_opt_i}`"
                    :value="opt"
                  >{{opt}}月</option>
                </select>

                <span class="text">/</span>

                <select
                  :id="`end-date-day-${colKey}`"
                  :data-vv-name="`end-date-day-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="下架日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-day-${colKey}`) }"
                  v-model="form.end_date[2]"
                  @change="updateDate('end')"
                >
                  <option value>日期</option>
                  <option
                    v-for="(opt, d_opt_i) in dateOpt_end"
                    :key="`end-date-${d_opt_i}`"
                    :value="opt"
                  >{{opt}}日</option>
                </select>
                &nbsp;
                <select
                  :id="`end-date-time-${colKey}`"
                  :data-vv-name="`end-date-time-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="下架日期"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-time-${colKey}`) }"
                  v-model="form.end_date[3]"
                >
                  <option value>時間</option>
                  <option
                    v-for="(opt, t_opt_i) in timeOpt"
                    :key="`end-time-${t_opt_i}`"
                    :value="opt"
                  >{{opt}}</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">
              選擇檔案
              <br />
              <small class="span-color-black">請上傳1280x720像素的圖檔</small>
            </th>
            <td>
              <div class="col-10 d-flex">
                <div v-if="form.photo_nm">
                  <span class="text">{{form.photo_nm}}</span>
                  <button type="button" class="btn btn-red" @click="doCleanFile">刪除</button>
                </div>
                <div class="d-flex" v-else>
                  <input id="file-upload" ref="myFiles" type="file" @change="changeInput()" />
                  <label for="file-upload" class="custom-file-upload btn btn-default m-0">上傳檔案</label>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">覆核人員</th>
            <td><span>{{form.approval_nm}}</span></td>
          </tr>
        </thead>
      </table>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doCancel" v-show="showCancelEditBtn">回上頁</a>
          <a class="btn btn-default" @click="doReset(true)" v-show="!isEditMode">重設</a>
          <a class="btn btn-default" @click="doPreview" :disabled="!form.photo_nm">預覽</a>
          <a class="btn btn-primary" @click="doSubmit(false)" v-show="showSubmitBtn" :class="{ 'disabled-link': !isModified }">送審</a> 
          <a class="btn btn-primary" @click="doDelete" v-show="showDeleteBtn" :class="{ 'disabled-link': isDeleteDisabled }">取消申請</a> 
          <a class="btn btn-primary" @click="doSubmit(true)" v-show="showApproveBtn">覆核</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />

    <!-- 預覽視窗 -->
    <popup-preview-modal
      :open="popupPreviewModalOpen"
      :file="file"
      :img="img"
      @close="panelClose('popupPreviewModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import mxMask from "@/desktop/components/mxMask";
import PopupPreviewModal from "@/desktop/views/backend/PopupPreviewModal";
//service
import { addPopupData } from "@/service";
import { updatePopupData, deletePopupData } from "@/service";
export default {
  name: "PopupContent",
  mixins: [commonMixin],
  components: { mxMask, PopupPreviewModal },
  props: {
    //廣告資訊
    popupInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    //編輯中
    isEdit: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    // 主旨連結
    editFromSubject: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    getName(){
      return Object.keys(this.popupInfo).length != 0 ? this.popupInfo.input_nm : this.UserInfo.name
    },
    showCancelEditBtn() {
      return (this.isEditMode && Object.keys(this.popupInfo).length !== 0);
    },
    showResetBtn() {
      return !this.isEditMode;
    },
    showDeleteBtn() {
      return this.isEditMode && this.popupInfo.release_status != 2 && this.editFromSubject;
    },
    isDeleteDisabled() {
      return this.popupInfo.approval_status == 0;
    },
    showSubmitBtn() {
      return this.editFromSubject && !(this.popupInfo.approval_status == 0 && this.popupInfo.release_status == 2)
    },
    showApproveBtn() {
      return this.isEditMode && this.popupInfo.approval_status == 1 && !this.editFromSubject;
    }
  },
  watch: {
    isEdit: function(val) {
      if (val) {
        this.setFormValue();
      }
    }
  },
  data() {
    return {
      today: window.moment(),
      yearOpt_start: [],
      yearOpt_end: [],
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dateOpt_start: [], //上架日期下拉選單
      dateOpt_end: [], //下架日期下拉選單
      timeOpt: [],
      mxMaskOpen: false,
      mxMaskContent: "資料儲存中，請稍候...",
      form: {
        ser_no: "", //序號
        photo_nm: "", //圖檔檔名
        photo_desc: "", //說明
        start_date: ["", "", "", ""], //上架日期
        end_date: ["", "", "", ""], //下架日期
        mod_id: "", //異動ID
        mod_datetime: "", //異動時間
        approval_id: "", //覆核人員ID 
        approval_nm: "", //覆核人員 
        input_id: "", //輸入人員ID
        input_nm: "", //輸入人員姓名
        last_start_date: "", //前一次覆核上架日期 
        last_end_date: "",   //前一次覆核下架日期  
      },
      file: {},
      initFileName: "", //原檔名(編輯模式才有值)
      init_start_date: "", //原有發佈日期(編輯模式才有值)
      init_end_date: "", //原有下架日期(編輯模式才有值)
      isDelete: false, //是否執行檔案刪除
      popupData: {},
      colKey: "1", //串欄位key用
      popupPreviewModalOpen: false,
      img: "",
      isFromSubject: '', // 是否點選名單名稱之連結
      isEditMode: false,
      isModified: false, //欄位是否異動
    };
  },
  methods: {
    ...mapActions(["setPageLock"]),
    isReadOnlyMode(){
      if(!this.editFromSubject){
        return this.popupInfo.approval_status == 1 ? true : false 
      }else{
        return (this.popupInfo.approval_status == 0 && this.popupInfo.release_status == 2) ? true : false;
      }
    },
    //是否欄位異動
    markAsEdited() {
      this.isModified = true;
    },
    //檢查主旨
    checkTitle() {
      if (this.stringBytes(this.form.photo_desc, false, 20) > 20) {
        this.form.photo_desc = this.form.photo_desc.substring(
          0,
          this.stringBytes(this.form.photo_desc, true, 20)
        );
      }
    },
    //下架日期-下拉選單初始化
    updateDate(type) {
      let year = "";
      let month = "";
      if (type == "start") {
        year = this.form.start_date[0];
        month = this.form.start_date[1];
      } else {
        year = this.form.end_date[0];
        month = this.form.end_date[1];
      }
      if (!year || !month) return;
      let dt = new Date(year, month, 0).getDate();
      if (type == "start") {
        this.dateOpt_start = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_start.push(i + 1);
        }
      } else {
        this.dateOpt_end = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_end.push(i + 1);
        }
      }
    },
    //清空檔案
    doCleanFile() {
      this.file = {};
      this.form.photo_nm = "";
      this.isDelete = true;
    },
    //整理更新資料
    doFormatData(reconfirm) {
      let errMsg = [];
      if (!this.form.photo_nm) {
        errMsg.push("請選擇檔案");
      }
      this.popupData = Object.assign({}, this.form);
      if(!reconfirm){
          this.popupData.mod_id = this.UserInfo.id;
      }
      if (this.initFileName && this.initFileName != this.popupData.photo_nm) {
        this.popupData.fileIsChanged = "Y"; //檔名不同，表示檔案異動過(編輯模式下)
      } else {
        if(!this.isEditMode){
          this.popupData.fileIsChanged = "Y" //新增操作，必須上傳新檔案
        }else{
          this.popupData.fileIsChanged = "N" //編輯模式，檔案未異動
        }
      }
      let startMonth =
        this.popupData.start_date[1].toString().length == 1
          ? "0" + this.popupData.start_date[1].toString()
          : this.popupData.start_date[1].toString();
      let startDate =
        this.popupData.start_date[2].toString().length == 1
          ? "0" + this.popupData.start_date[2].toString()
          : this.popupData.start_date[2].toString();

      this.popupData.start_date =
        this.form.start_date[0] + "-" + startMonth + "-" + startDate;

      let dd = new Date();
      let todayStr =
        dd.getFullYear() +
        "-" +
        parseInt(dd.getMonth() + 1) +
        "-" +
        dd.getDate();
      let d_Today = new Date(todayStr);
      let d_Start_Date = new Date(this.popupData.start_date); //沒有串時間，因為要與今天日期比較
      this.popupData.start_date =
        this.popupData.start_date + " " + this.form.start_date[3] + ":00"; //ex. 2021-07-23 10:30:00

      //修改先前的發佈資料時，發佈日期若無修改不用再進行檢核 (true:不檢核)
      let noCheckStartDate =
        this.form.mod_datetime &&
        this.init_start_date == this.popupData.start_date;

      if (!noCheckStartDate && d_Today.getTime() > d_Start_Date.getTime()) {
        errMsg.push("發佈日期不得早於當日"); //若發佈日期的年月日=今日，時間可小於當前時間
      }

      let endMonth =
        this.popupData.end_date[1].toString().length == 1
          ? "0" + this.popupData.end_date[1].toString()
          : this.popupData.end_date[1].toString();
      let endDate =
        this.popupData.end_date[2].toString().length == 1
          ? "0" + this.popupData.end_date[2].toString()
          : this.popupData.end_date[2].toString();
      this.popupData.end_date =
        this.form.end_date[0] +
        "-" +
        endMonth +
        "-" +
        endDate +
        " " +
        this.popupData.end_date[3] +
        ":00"; //ex. 2021-07-23 10:30:00
      d_Start_Date = new Date(this.popupData.start_date); //有多串時間
      let d_End_Date = new Date(this.popupData.end_date);
      if (d_Start_Date.getTime() > d_End_Date.getTime()) {
        errMsg.push("下架日期不得早於發佈日");
      } else if (d_Start_Date.getTime() == d_End_Date.getTime()) {
        errMsg.push("下架日期不得等於發佈日");
      }

      // 審核進度賦值
      if(!this.popupData.approval_status){
        if(this.editFromSubject){
          this.popupData.approval_status = 1
        }else{
          this.popupData.approval_status = 0
        }
      }else{
        this.popupData.approval_status = 1
      }

      //是否執行覆核操作
      this.popupData.reconfirm = reconfirm

      //覆核人員
      this.popupData.approval_id = this.$store.state.userInfo.id
      this.popupData.approval_nm = this.$store.state.userInfo.name

      //如果進行覆核操作，輸入人員不會變
      if(this.popupData.approval_status == 1 && reconfirm){
        this.popupData.approval_status = 0
      } else {
        // 非覆核操作，如果欄位有異動，輸入人員調整為當前業務員，若無異動則不變
        if(this.isModified){
          this.popupData.input_id = this.$store.state.userInfo.id
          this.popupData.input_nm = this.$store.state.userInfo.name
        }    
      }

      this.popupData.init_start_date = this.init_start_date;
      this.popupData.init_end_date = this.init_end_date;
      this.popupData.initFileName = this.initFileName;
      this.popupData.last_start_date = this.form.last_start_date;
      this.popupData.last_end_date = this.form.last_end_date;

      return errMsg;
    },
    //取消編輯
    doCancel() {
      this.$emit("doCancelEdit");
    },
    //重設
    doReset(showMsg) {
      this.form = {
        ser_no: "", //序號
        photo_nm: "", //圖檔檔名
        photo_desc: "", //說明
        start_date: ["", "", "", ""], //上架日期
        end_date: ["", "", "", ""], //下架日期
        mod_id: "", //異動ID
        mod_datetime: "" //異動時間
      };
      this.file = {};
      if (showMsg) {
        this.$toast.info({ title: "畫面重設成功" });
      }
    },
    doDelete(){
        this.doFormatData(false);
        deletePopupData(this.UserInfo.id, this.popupData).then(
          result => {
            if (result.header && result.header.status == "200") {
              this.setToastMsg(result.header.message);
              this.$emit(
                "doQuery",
                this.popupData.start_date.substring(0, 10),
                "Y"
              );
            } else {
              this.setToastMsg(result.header.message);
            }
          }
       );
    },
    //預覽
    doPreview() {
      if (!this.form.photo_nm) {
        return;
      }
      if (this.isDelete) {
        this.img = "";
      }
      this.popupPreviewModalOpen = true;
    },
    doSubmit(reconfirm) {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        let errMsg = this.doFormatData(reconfirm);
        if (errMsg && errMsg.length > 0) {
          errMsg.forEach(err => {
            this.$toast.info({ title: err }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.mxMaskOpen = true;
        if (this.form.mod_datetime) {
          if (
            this.init_start_date != this.popupData.start_date ||
            this.init_end_date != this.popupData.end_date
          ) {
            //有異動過發佈日期or下架日期
            this.popupData.isChangeTime = "Y";
          }
          //修改
          updatePopupData(
            this.UserInfo.id,
            this.popupData,
            this.popupData.fileIsChanged == "Y" ? this.file : "",
          ).then(result => {
            this.mxMaskOpen = false;
            if (result.header && result.header.status == "200") {
              this.setToastMsg(result.header.message);
              //編輯成功, 關閉編輯區塊, 重新查詢
              this.$emit(
                "doQuery",
                moment().format("YYYY-MM-DD"),
                "Y"
              );
            } else {
              this.setToastMsg(result.header.message);
            }
          });
        } else {
          //新增
          addPopupData(this.UserInfo.id, this.popupData, this.file).then(
            result => {
              this.mxMaskOpen = false;
              if (result.header && result.header.status == "200") {
                this.setToastMsg(result.header.message);
                //新增成功, 導頁到彈跳式廣告查詢頁面
                this.$router.push({
                  name: "backend-tab3-2"
                });
              } else {
                this.setToastMsg(result.header.message);
              }
            }
          );
        }
      });
    },
    linkToPopupView(){
      this.$router.push({ path: "/backend/tab/3-2" });
      this.$nextTick(() => {
        this.$router.go(0); 
      });
    },
    //檔案上傳
    changeInput() {
      let vm = this;
      if (!vm.$refs.myFiles.files || vm.$refs.myFiles.files.length == 0) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.file = vm.$refs.myFiles.files[0];
      let fileType = vm.file.type;
      //檢查檔案類型 (只允許 image/png, image/jpeg)
      if (fileType.indexOf("png") !== -1 || fileType.indexOf("jpeg") !== -1) {
        //檢查檔案大小
        if (vm.$refs.myFiles.files[0].size > 5000000) {
          vm.setToastMsg("檔案不得超過5MB");
          vm.file = {};
          vm.form.photo_nm = "";
        } else {
          vm.file = vm.$refs.myFiles.files[0];
          vm.form.photo_nm = vm.file.name;
        }
      } else {
        vm.setToastMsg("檔案格式不支援");
        vm.file = {};
        vm.form.photo_nm = "";
      }
    },
    //編輯模式塞值
    setFormValue() {
      if (
        this.popupInfo &&
        this.popupInfo.start_date &&
        this.popupInfo.end_date
      ) {
        this.doReset(false); //清空畫面上原有的值
        this.isDelete = false;
        this.isEditMode = true;
        this.form.ser_no = this.popupInfo.ser_no;
        this.form.mod_datetime = this.popupInfo.mod_datetime;
        this.form.photo_desc = this.popupInfo.photo_desc;
        this.img = this.popupInfo.photo_nm || ""; //預覽用
        this.form.photo_nm = this.popupInfo.photo_nm || "";
        this.initFileName = this.popupInfo.photo_nm || "";

        this.init_start_date = this.popupInfo.start_date.substring(
          0,
          this.popupInfo.start_date.length - 2
        );
        this.init_end_date = this.popupInfo.end_date.substring(
          0,
          this.popupInfo.end_date.length - 2
        );

        let start_date = this.popupInfo.start_date || "";
        let start_dateArr = start_date.split("-");
        this.form.start_date[0] = start_dateArr[0]; //年
        if (parseInt(start_dateArr[1]) > 9) {
          this.form.start_date[1] = start_dateArr[1]; //月
        } else {
          this.form.start_date[1] = start_dateArr[1].replace("0", ""); //月 (去除0)
        }
        if (!this.yearOpt_start.includes(parseInt(this.form.start_date[0]))) {
          this.form.start_date[0] = "";
        }
        this.updateDate("start");
        let startD = start_dateArr[2].substring(0, 2);
        let startT = start_dateArr[2].substring(3, 8);
        if (parseInt(startD) > 9) {
          this.form.start_date[2] = startD; //日
        } else {
          this.form.start_date[2] = startD.replace("0", ""); //日 (去除0)
        }
        this.form.start_date[3] = startT; //時分

        let end_date = this.popupInfo.end_date || "";

        let end_dateArr = end_date.split("-");
        this.form.end_date[0] = end_dateArr[0]; //年
        if (parseInt(end_dateArr[1]) > 9) {
          this.form.end_date[1] = end_dateArr[1]; //月
        } else {
          this.form.end_date[1] = end_dateArr[1].replace("0", ""); //月 (去除0)
        }
        if (!this.yearOpt_end.includes(parseInt(this.form.end_date[0]))) {
          this.form.end_date[0] = "";
        }
        this.updateDate("end");
        let endD = end_dateArr[2].substring(0, 2);
        let endT = end_dateArr[2].substring(3, 8);
        if (parseInt(endD) > 9) {
          this.form.end_date[2] = endD; //日
        } else {
          this.form.end_date[2] = endD.replace("0", ""); //日 (去除0)
        }
        this.form.end_date[3] = endT; //時分

        this.form.mod_id = this.popupInfo.mod_id || "";
        this.form.input_id = this.popupInfo.input_id || "";
        this.form.input_nm = this.popupInfo.input_nm || "";
        this.form.approval_id = this.popupInfo.approval_id || "";
        this.form.approval_nm = this.popupInfo.approval_nm || "";
        this.form.last_start_date = this.popupInfo.last_start_date || "";
        this.form.last_end_date = this.popupInfo.last_end_date || "";
      }
    }
  },
  mounted() {
    let start = window.moment().year();
    for (let s = start; s <= start + 2; s++) {
      this.yearOpt_start.push(s);
      this.yearOpt_end.push(s);
    }

    let hourStr = "";
    let minuteStr = "";
    for (let i = 0; i < 24; i++) {
      if (i < 10) {
        hourStr = "0" + i;
      } else {
        hourStr = i;
      }
      for (let j = 0; j < 2; j++) {
        if (j == 0) {
          minuteStr = ":00";
        } else {
          minuteStr = ":30";
        }
        this.timeOpt.push(hourStr + minuteStr);
      }
    }
  }
};
</script>
<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.span-color-black {
  color: black;
}

.readonly-table {
  pointer-events: none; /* 禁用點擊 */
}
.readonly-table input,
.readonly-table select,
.readonly-table textarea,
.readonly-table button,
.readonly-table label,
.readonly-table .custom-file-upload {
  pointer-events: none;
  filter: grayscale(100%);
  background-color: #f5f5f5 !important; 
  color: #999 !important;
  border-color: #ccc !important;
  cursor: not-allowed; 
}

.readonly-table input[type="checkbox"],
.readonly-table input[type="radio"] {
  opacity: 0.6;
}

.disabled-link {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
  background: #C2C4C7 !important;
  pointer-events: none;
  cursor: not-allowed;
}
</style>